import React from 'react';
import PropTypes from 'prop-types';
import { Placeholder } from './../loading-state/placeholder';

import * as genericHelper from 'src/app-lib/helpers/genericHelper';

export class ContentVideo extends React.Component {
    constructor(props) {
        super(props);
    }

    displayContentThumbnail() {
        return (
            <div>
                <img className="content-video__thumbnail" data-card-type={`${this.props.cardType}`} alt="" src={this.props.contentThumbnail} />
                {this.props.contentDuration ? <div className="content-video__duration">{genericHelper.hmsTimeFormatFromSeconds(this.props.contentDuration)}</div> : null}
            </div>
        );
    }

    render() {
        const { isFetching } = this.props;
        return (
            <div className="content-video" data-card-type={`${this.props.cardType}`} >
                {isFetching ? <Placeholder height={'100%'} width={'100%'} margin={'0px'} type={'plain'} /> : this.displayContentThumbnail()}
            </div>
          );
    }
}

ContentVideo.propTypes = {
    contentDuration: PropTypes.number,
    contentThumbnail: PropTypes.string,
    isFetching: PropTypes.number,
    cardType: PropTypes.string
};

ContentVideo.defaultProps = {
    contentDuration: null,
    contentThumbnail: null,
    isFetching: null,
    cardType: '',
};



// WEBPACK FOOTER //
// ./src/components/SharedComponents/content/content-video.js